import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { QuotaLine } from '../components/billing/resource-meter.js';
import { CustomersPanel } from '../components/customers/customers-panel.js';
import { WorkspaceThemeSurface } from '../components/layout/workspace-theme.js';
import { useQuota } from '../lib/billing/use-billing.js';

/**
 * The customer book: the sheet is the screen.
 *
 * No page header — a title band restating what the highlighted navigation item already says costs
 * four rows of a sheet that is read by scrolling. The controls it carried (Add, Export) are in the
 * sheet's own toolbar. The heading survives for screen readers, which genuinely do need the route
 * to announce itself.
 *
 * The screen is still search-first. The counter's first action is "find this person, or make
 * them", so the search box takes focus and an empty result offers to create them with what was
 * typed — see `CustomersPanel`.
 */
export function CustomersPage(): ReactElement {
  const { t } = useTranslation();
  const customerQuota = useQuota('customers');

  return (
    <WorkspaceThemeSurface fillsViewport className="flex flex-col gap-3 md:min-h-0 md:flex-1">
      <h2 className="sr-only">{t('customers.title')}</h2>
      {/* The allowance, and only once it is worth pointing at: the person about to add the
          four-hundred-and-ninety-eighth customer is standing here, not on the billing screen. */}
      <QuotaLine usage={customerQuota} />
      <CustomersPanel />
    </WorkspaceThemeSurface>
  );
}

export default CustomersPage;
